"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.yellow = exports.virilisGreen = exports.teal = exports.silver = exports.salesforce = exports.red = exports.malachite = exports.green = exports.denim = exports.cobalt = exports.blue = void 0;
var blueTheme_1 = require("./blueTheme");
Object.defineProperty(exports, "blue", { enumerable: true, get: function () { return blueTheme_1.blueTheme; } });
var cobaltTheme_1 = require("./cobaltTheme");
Object.defineProperty(exports, "cobalt", { enumerable: true, get: function () { return cobaltTheme_1.cobaltTheme; } });
var denimTheme_1 = require("./denimTheme");
Object.defineProperty(exports, "denim", { enumerable: true, get: function () { return denimTheme_1.denimTheme; } });
var greenTheme_1 = require("./greenTheme");
Object.defineProperty(exports, "green", { enumerable: true, get: function () { return greenTheme_1.greenTheme; } });
var malachiteTheme_1 = require("./malachiteTheme");
Object.defineProperty(exports, "malachite", { enumerable: true, get: function () { return malachiteTheme_1.malachiteTheme; } });
var redTheme_1 = require("./redTheme");
Object.defineProperty(exports, "red", { enumerable: true, get: function () { return redTheme_1.redTheme; } });
var salesforceTheme_1 = require("./salesforceTheme");
Object.defineProperty(exports, "salesforce", { enumerable: true, get: function () { return salesforceTheme_1.salesforceTheme; } });
var silverTheme_1 = require("./silverTheme");
Object.defineProperty(exports, "silver", { enumerable: true, get: function () { return silverTheme_1.silverTheme; } });
var tealTheme_1 = require("./tealTheme");
Object.defineProperty(exports, "teal", { enumerable: true, get: function () { return tealTheme_1.tealTheme; } });
var virilisGreenTheme_1 = require("./virilisGreenTheme");
Object.defineProperty(exports, "virilisGreen", { enumerable: true, get: function () { return virilisGreenTheme_1.virilisGreenTheme; } });
var yellowTheme_1 = require("./yellowTheme");
Object.defineProperty(exports, "yellow", { enumerable: true, get: function () { return yellowTheme_1.yellowTheme; } });
//# sourceMappingURL=index.js.map